/* eslint-disable strict */
module.exports = /*@ngInject*/ function DisplayCustomTrainTypeName() {
    return function (trainType, customTrainTypeNames) {
        var displayName = customTrainTypeNames[trainType.code] && customTrainTypeNames[trainType.code].displayName;
        return trainType.count !== undefined ? `${displayName} (${trainType.count})` : displayName;
    }
};
